import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { TYPES as UTIL_TYPES } from '@monofe/util';
import { TYPES as API_TYPES } from '../../api/interface/bind';
import type { IJobs } from '../interface';
import { bindJobs, injectJobs, TYPES, unbindJobs } from '../interface/bind';
import deleteBinder from './delete.bind';
import downloadBinder from './download.bind';
import updateSiteBinder from './updateSite/updateSite.bind';

function _build(container: IContainer): Readonly<IJobs> {
    const tasks: IJobs = {
        updateSite: updateSiteBinder(container),
        downloadMedia: downloadBinder.downloadMedia(container),
        downloadMediaNoResponse: downloadBinder.downloadMediaNoResponse(container),
        deleteMedia: deleteBinder(container),
    };

    return Object.freeze(tasks);
}

export default buildBindable<IJobs>({
    id: TYPES.IJobs,
    dependencies: [
        UTIL_TYPES.IProgressPromiseGenerator,
        API_TYPES.IMediaAPI,
        API_TYPES.ISiteDataAPI,
        UTIL_TYPES.IConfigAPI,
    ],
    bind: bindJobs,
    remove: unbindJobs,
    build: container => Promise.resolve(_build(container)),
    inject: injectJobs,
});
